import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category8s',
  templateUrl: './textile-model-category8s.component.html',
  styleUrls: ['./textile-model-category8s.component.css']
})
export class TextileModelCategory8sComponent implements OnInit {
    public itemsListCategories8: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadCategories8(): Promise<void> {
        this.itemsListCategories8 = await this.datatask.Post(2701);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'textilemodelcategory8':
                this.stateService?.go('textilemodelcategory8', { textilemodelcategory8_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadCategories8();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory8s', {
//        templateUrl: 'views/components/views/textileModelCategory8s/textileModelCategory8s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory8sService', function (stateService, textileModelCategory8sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListCategories8: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadCategories8() {
//                vm.model.itemsListCategories8 = await textileModelCategory8sService.listTextileModelCategory8s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory8':
//                        go({ textilemodelcategory8_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadCategories8();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
